.star__wrapper {
  line-height: 1;
}

.star__color-filled {
  fill: #ffd100;
}

.star__color-empty {
  fill: #cbcbcb;
}

.product-rating {
  display: flex;
  align-items: center;
  font-size: 0;
  text-decoration: none;
}

.product-rating:hover, .product-rating:focus, .product-rating:active {
  text-decoration: none;
}

.product-rating__wrapper {
  position: relative;
  bottom: 1px;
  line-height: 1;
}

:host(:not([dir="rtl"])) .product-rating__wrapper {
  margin-right: 5px;
}

:host([dir="rtl"]) .product-rating__wrapper {
  margin-left: 5px;
}

.product-rating__inner-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.product-rating__rating-count, .product-rating__review-count {
  line-height: 1.25rem;
  font-size: 0.75rem;
  color: #42b4e6;
  white-space: nowrap;
}

:host(:not([dir="rtl"])) .product-rating__rating-count {
  margin-right: 5px;
}

:host([dir="rtl"]) .product-rating__rating-count {
  margin-left: 5px;
}